import React, { useState } from 'react';
import { TextField, Button } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import Alert from '@material-ui/lab/Alert';
import { useDispatch } from 'react-redux';
import { loginAction } from '../../actions/loginActions';
import "./Login.css";

function LoginForm() {
    const dispatch = useDispatch();
    const history = useHistory();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email || !password) {
            return setError('Please enter both email and password');
        }

        try {
            setError('');
            setLoading(true);
            const result = await dispatch(loginAction(email, password));
            // Redirect based on role
            if (result.role === 'admin') {
                history.push('/admin/dashboard');
            } else {
                history.push('/usertests');
            }
        } catch (error) {
            setError(error.message || 'Failed to login. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="loginForm_main">
            {error && <Alert severity="error" className="error_login">{error}</Alert>}
            <form onSubmit={handleSubmit} className="lForm__main">
                <TextField
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="quizForm__textfield"
                    fullWidth
                    id="email"
                    name="email"
                    label="Email"
                    variant="filled"
                    type="email"
                />
                <TextField
                    required
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="quizForm__textfield"
                    fullWidth
                    id="password"
                    name="password"
                    label="Password"
                    variant="filled"
                />
                <div className="loginForm__footer">                    
                    <Button 
                        type="submit"
                        className="login-button"
                        disabled={loading}
                    >
                        {loading ? 'Logging in...' : 'Login'}
                    </Button>                    
                    <div className='loginForm__footerhelper'>
                        <Link to='/register' className='helpLinks'>Register</Link>
                        <div>
                            <Link to='/forgot-password' className='helpLinks'>Forgot Password</Link>
                        </div>                        
                    </div>
                </div>
            </form>
        </div>
    );
}

export default LoginForm;